module.exports = __webpack_public_path__ + "img/hangxian.8e267dee.jpg";